<template>
  <md-card>
    <md-card-header md-alignment="space-between">
      <h4 class="title">
        <md-icon>assignment</md-icon>
        기부자 상세
      </h4>
    </md-card-header>
    <md-card-content>
      <div
        style="position: absolute; top: 29px; right: 10px;"
        v-show="query.updateDate"
      >
        최근수정일 : {{ query.updateDate }}
      </div>
      <h4>기본 정보</h4>
      <table class="flex-table">
        <tr>
          <th star>교우명</th>
          <td>
            <div class="inline-flex">
              <input type="text" disabled v-model="memberInfo.memberHnm" />
              <button @click="isShowMemberModal = true" v-show="!isEdit">
                <md-icon>search</md-icon>
              </button>
            </div>
          </td>
          <th>교우직위</th>
          <td>
            <input type="text" v-model="memberInfo.memberorgGbNm" disabled />
          </td>
          <th>대학</th>
          <td>
            <input type="text" v-model="memberInfo.collegeCdNm" disabled />
          </td>
          <th>학과</th>
          <td>
            <input type="text" v-model="memberInfo.classCdNm" disabled />
          </td>
          <th>학번</th>
          <td>
            <input type="text" v-model="memberInfo.hakbun" disabled />
          </td>
        </tr>
        <tr>
          <th>핸드폰</th>
          <td>
            <input type="text" v-model="memberInfo.cellular" disabled />
          </td>
          <th>직장정보</th>
          <td>
            <input type="text" v-model="memberInfo.companyNm" disabled />
          </td>
          <th>생년월일</th>
          <td>
            <input type="text" :value="getDateFormat(memberInfo.birthday)" disabled />
          </td>
          <th>직위</th>
          <td>
            <input type="text" v-model="memberInfo.levelNm" disabled />
          </td>
          <th>직장 FAX</th>
          <td>
            <input type="text" v-model="memberInfo.fax" disabled />
          </td>
        </tr>
        <tr>
          <th>자택</th>
          <td colspan="5">
            <div class="inline-flex">
              <input
                type="text"
                class="w60"
                v-model="memberInfo.homeZipcd"
                disabled
              />
              <input type="text" v-model="memberInfo.homeAddress1" disabled />
              <input type="text" v-model="memberInfo.homeAddress2" disabled />
            </div>
          </td>
          <th>eMail 1</th>
          <td>
            <input type="text" v-model="memberInfo.eMail" disabled />
          </td>
          <th>자택 연락처</th>
          <td>
            <input type="text" v-model="memberInfo.homeTel" disabled />
          </td>
        </tr>
        <tr>
          <th>직장</th>
          <td colspan="5">
            <div class="inline-flex">
              <input
                type="text"
                class="w60"
                v-model="memberInfo.officeZipcd"
                disabled
              />
              <input type="text" v-model="memberInfo.officeAddress1" disabled />
              <input type="text" v-model="memberInfo.officeAddress2" disabled />
            </div>
          </td>
          <th>eMail 2</th>
          <td>
            <input type="text" v-model="memberInfo.eMail2" disabled />
          </td>
          <th>직장 연락처</th>
          <td>
            <input type="text" v-model="memberInfo.officeDirect" disabled />
          </td>
        </tr>
        <tr>
          <th>기타주소</th>
          <td colspan="5">
            <div class="inline-flex">
              <input
                type="text"
                class="w60"
                v-model="query.etcZipcd"
              />              
              <button @click="addressModalOpen('etc')">
                <md-icon>search</md-icon>
              </button>
              <input type="text" v-model="query.etcAddress1" />
              <input type="text" v-model="query.etcAddress2" />
            </div>
          </td>
        </tr>
      </table>

      <!-- <h3 style="text-align: center; color: red;"> 저장은 {{ originalSemesterCd }} 학기로 저장됩니다.</h3> -->

      <h4>기부교우 담당자</h4>
      <table class="flex-table">
        <tr>
          <th>조회할 학기 선택</th>
          <td>
            <div class="inline-flex">
              <select
                v-model="query.semesterCd"
                name="semesterCd"
                @change="changeSemesterCd"
              >
                <option value="">선택</option>
                <option
                  v-for="item in semesterCdList"
                  :key="item.code"
                  :label="item.codeNm"
                  :value="item.code"
                >
                  {{ item }}
                </option>
              </select>       
      <!-- <md-button
        class="md-default md-sm"
        style="margin-left: 8px;"
        @click="loadLatestSemesterInfo"
        :disabled="!query.memberNo"
      >
        최근정보 불러오기
      </md-button> -->
            </div>
          </td>
          <th>직장명</th>
          <td>
            <input type="text" v-model="query.companyName" />
          </td>
          <th>직위</th>
          <td>
            <input type="text" v-model="query.levelNm" />
          </td>
          <th>실무담당자</th>
          <td>
            <input type="text" v-model="query.managerNm" />
          </td>
          <th>이메일</th>
          <td>
            <input type="text" v-model="query.eMail" />
          </td>
        </tr>
        <tr>
          <th>책임자</th>
          <td>
            <input type="text" v-model="query.secNm" />
          </td>
          <th>부서직위</th>
          <td>
            <input type="text" v-model="query.secPosition" />
          </td>
          <th>직장전화</th>
          <td>
            <input type="text" v-model="query.officePhone" />
          </td>
          <th>핸드폰</th>
          <td>
            <input type="text" v-model="query.celluar" v-mask-phone-number />
          </td>
          <th>FAX</th>
          <td>
            <input type="text" v-model="query.fax" />
          </td>
        <tr></tr>
        </tr>
        <tr>
          <th>기부영수증</th>
          <td>
            <label
              ><input
                type="radio"
                name="receiptGb"
                value="Y"
                v-model="query.receiptGb"
              />본인</label
            >
            <label
              ><input
                type="radio"
                name="receiptGb"
                value="N"
                v-model="query.receiptGb"
              />법인</label
            >
          </td>
          <th>지급형태</th>
          <td>            
            <label
              ><input
                type="radio"
                name="giveGb"
                value="1"
                v-model="query.giveGb"
              />교우</label
            >
            <label
              ><input
                type="radio"
                name="giveGb"
                value="2"
                v-model="query.giveGb"
              />비교우</label
            >
            <label
              ><input
                type="radio"
                name="giveGb"
                value="3"
                v-model="query.giveGb"
              />단체</label
            >
          </td>
          <th>발송조건(학생서류)</th>
          <td>            
            <label
              ><input
                type="radio"
                name="sendCondition"
                value="1"
                v-model="query.sendCondition"
              />E-mail</label
            >
            <label
              ><input
                type="radio"
                name="sendCondition"
                value="2"
                v-model="query.sendCondition"
              />FAX</label
            >
            <label
              ><input
                type="radio"
                name="sendCondition"
                value="3"
                v-model="query.sendCondition"
              />기타</label
            >
          </td>
          <th>특이사항</th>
          <td colspan="3">
            <input type="text" v-model="query.etc" />
          </td>
        </tr>
        <tr>
          <th>약정서발송주소</th>
          <td>                        
            <label
              ><input
                type="radio"
                name="sendTo"
                value="1"
                v-model="query.sendTo"
              />자택</label
            >
            <label
              ><input
                type="radio"
                name="sendTo"
                value="2"
                v-model="query.sendTo"
              />직장</label
            >
            <label
              ><input
                type="radio"
                name="sendTo"
                value="3"
                v-model="query.sendTo"
              />기타</label
            >
            <label
              ><input
                type="radio"
                name="sendTo"
                value="4"
                v-model="query.sendTo"
              />이메일</label
            >
          </td>
          <td colspan="8">
            <div class="inline-flex">
              <input
                type="text"
                class="w60"
                v-model="query.agreemZipcd"
                disabled
              />
              <button @click="addressModalOpen('agreem')">
                <md-icon>search</md-icon>
              </button>
              <input
                type="text"
                placeholder="기본주소"
                disabled
                v-model="query.agreemAddress1"
              />
              <input
                type="text"
                placeholder="상세주소"
                v-model="query.agreemAddress2"
              />
            </div>
          </td>
        </tr>
      </table>

      <h4>지급특성</h4>
      <table class="flex-table">
        <tr>
          <th>지급조건</th>
          <td><input type="text" v-model="query.conditionGive" /></td>
          <th>세부조건</th>
          <td><input type="text" v-model="query.conditionDetail" /></td>
          <th>비고(지급)</th>
          <td><input type="text" v-model="query.conditionEtc" /></td>
          <th class="letter-dense">약정 구좌</th>
          <td>
            <div class="inline-flex">
              <input
                type="number"
                disabled
                v-model="accountNo"
                placeholder="구좌[자동계산]"
              />
              <input
                type="text"
                v-model="query.agreemAmount"
                placeholder="약정금액을 입력하세요"
                oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/\d(?=(?:\d{3})+$)/g, '$&,')"
              />
            </div>
          </td>
          <th>입금일자</th>
          <td>
            <input
              type="text"
              v-model="query.depositDate"
              v-mask="'####-##-##'"
            />
          </td>
        </tr>
        <tr>
          <th>실 입금액</th>
          <td>
            <input
              type="text"
              v-model="query.giveAmount"
              placeholder="실 입금액을 입력하세요"
              oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/\d(?=(?:\d{3})+$)/g, '$&,')"
            />
          </td>
          <th>지정여부</th>
          <td>
            <label
              ><input
                type="radio"
                name="designateGb"
                value="Y"
                v-model="query.designateGb"
              />본인</label
            >
            <label
              ><input
                type="radio"
                name="designateGb"
                value="N"
                v-model="query.designateGb"
              />교우회 위임</label
            >
          </td>
          <th class="letter-dense">기부금(기본재산)</th>
          <td>
            <input
              type="text"
              v-model="query.baseAmount"
              placeholder="기부금을 입력하세요"
            />
          </td>
          <th>연계장학금<br>(직접지급)</th>
          <td><input type="text" v-model="query.agreemExecDesignate" /></td>
          <th>약정변동내역</th>
          <td ><input type="text" v-model="query.changeDesc" /></td>
        </tr>
        <tr>
          <th class="letter-dense">담당부서(교내포함)</th>
          <td><input type="text" v-model="query.recomPart" /></td>
          <th>학장</th>
          <td><input type="text" v-model="query.recomDean" /></td>
          <th>부장(차장)</th>
          <td><input type="text" v-model="query.recomDirector" /></td>
          <th>담당자</th>
          <td><input type="text" v-model="query.recomManager" /></td>
        </tr>
        <tr>
          <!-- <th>교우회 위임</th>
          <td>
            <label
              ><input
                type="radio"
                name="agreemExecMendateGb"
                value="Y"
                v-model="query.agreemExecMendateGb"
              />Y</label
            >
            <label
              ><input
                type="radio"
                name="agreemExecMendateGb"
                value="N"
                v-model="query.agreemExecMendateGb"
              />N</label
            >
          </td> -->
          <th>약정서 첨부</th>
          <td>
            <input
              type="file"
              accept=".doc,.hwp,.pdf,.ppt,.xlsx"
              class="hidden-input-file"
              id="donatorFileInput"
            />
            <span
              type="button"
              @click="onClickSearchFile"
              style="cursor: pointer"
            >
              <md-icon>search</md-icon>
            </span>
            <span @click="onClickDownLoad" style="cursor: pointer;">
              {{ query.orgFileNm }}
            </span>
            <span
              v-show="query.orgFileNm"
              @click="onClickDeleteFile"
              style="cursor: pointer;"
            >
              <md-icon>delete</md-icon>
            </span>
          </td>
          <th>섭외담당자</th>
          <td>
            <select v-model="query.agreemFindmanCd">
              <option value="">선택</option>
              <option>교우회장</option>
              <option>사무총장</option>
              <option>운영국장</option>
              <option>장학담당</option>
              <option>기타</option>
            </select>
          </td>
          <th>특수관계인</th>
          <td><input type="text" v-model="query.agreemExecSpecPerson" /></td>
          <th>기타(약정)</th>
          <td colspan="3">
            <input type="text" v-model="query.agreemExecEtc" />
          </td>
        </tr>
        <tr>
          <th>기탁계기</th>
          <td colspan="3"><input type="text" v-model="query.donateMotive" /></td>
          <th>기탁개시일</th>
          <td><input type="text" v-model="query.donateStartDate" v-mask="'####-##-##'" /></td>
          <th>기본재산편입일 </th>
          <td><input type="text" v-model="query.baseStartDate" v-mask="'####-##-##'" /></td>
          <th>비고(약정)</th>
          <td><input type="text" v-model="query.agreemEtc" /></td>
        </tr>
        <tr>          
          <th>비고(추천)</th>
          <td colspan="9"><input type="text" v-model="query.recomEtc" /></td>
        </tr>
      </table>
    </md-card-content>

    <md-card-actions md-alignment="right">
      <md-button class="md-default md-sm" @click="resetEditView">
        <md-icon>clear</md-icon>초기화
      </md-button>
      <md-button
        class="md-info md-sm"
        @click="saveDonator"
        :disabled="
          !query.memberNo ||
            query.memberNo == '' ||
            !query.semesterCd ||
            query.semesterCd == ''
        "
      >
        <md-icon>check</md-icon>저장
      </md-button>
      <md-button
        class="md-default md-sm"
        @click="deleteDonator"
        :disabled="
          !query.memberNo ||
            query.memberNo == '' ||
            !query.semesterCd ||
            query.semesterCd == ''
        "
        v-if="isEdit"
      >
        <md-icon>clear</md-icon>삭 제
      </md-button>
      <md-button class="md-info md-sm" @click="setDonatorReciptPrint"
        ><md-icon>receipt</md-icon>영수증
      </md-button>
      <md-button class="md-info md-sm" @click="$emit('openPrintableDonator', {...query, memberInfo})"
        ><md-icon>contact_page</md-icon>기부자 카드
      </md-button>
    </md-card-actions>

    <div
      id="print"
      style="position: fixed; top: 30%; left: 50%; transform:translate(-50%, -50%);  z-index: 999999999;
    width: 500px; height: 450px; background: #fff; padding: 20px;
-webkit-box-shadow: 0px 0px 15px 5px rgba(0,0,0,0.40);
box-shadow: 0px 0px 15px 5px rgba(0,0,0,0.40);
  border-radius: 5px;
"
      v-show="isShowDonatorPrintModal"
    >
      <div
        style="outline: 2px solid #222; padding: 20px; width: 100%; height: 85%;"
      >
        <div
          class="alce"
          style="font-size: 35px;color: #7b0024;font-family: 'Nanum Myeongjo', serif;font-weight: 600;text-align: center; "
        >
          <h4 class="flex-table" style="margin-top: 27px; margin-bottom: 30px;">
            기부자 영수증
          </h4>
        </div>
        <table class="flex-table" style="border: 0; font-size: 14px;">
          <caption class="blind"></caption>
          <colgroup>
            <col width="160px" class="flex-table" />
            <col width="" />
          </colgroup>
          <thead>
            <tr>
              <th
                style="border: 0;background: none;text-align: left; padding: 10px 0 6px 50px;font-size:14px;"
              >
                기부자 교우번호
              </th>
              <td style="border: 0;font-size:14px;background: none;">
                {{ memberInfo.memberNo }}
              </td>
            </tr>
            <tr>
              <th
                style="border: 0;background: none;text-align: left;padding: 10px 0 6px 50px;font-size:14px;"
              >
                기부자명
              </th>
              <td style="border: 0;font-size:14px;background: none;">
                {{ memberInfo.memberHnm }}
              </td>
            </tr>
            <tr>
              <th
                style="border: 0;background: none;text-align: left;padding: 10px 0 6px 50px;font-size:14px;"
              >
                실 입금액
              </th>
              <td style="border: 0;font-size:14px;background: none;">
                <p class="medical_year">{{ query.giveAmount }}</p>
              </td>
            </tr>
          </thead>
        </table>

        <div style="text-align: center">
          <label id="today" value=""></label>
        </div>

        <div style="text-align: center;">
          <img
            src="../../../../public/img/medical_sign.jpg"
            style="width: 250px; height: 64px;"
          />
        </div>

        <div
          style="position: absolute; left: 50%; transform: translateX(-50%); top: 90px;z-index: -99;"
        >
          <img
            src="../../../../public/img/watermark.png"
            height="150"
            width="150"
          />
        </div>
      </div>

      <div
        id="printbutton"
        class="flex-table"
        style="text-align: center;margin-top: 20px"
      >
        <md-button
          class="md-info"
          @click="printDonatorReceipt()"
          :aria-disabled="isShowDonatorPrintModal"
          style="margin-right: 10px;width: 140px;font-size:15px;"
          >출력</md-button
        >
        <md-button
          class="md"
          @click="isShowDonatorPrintModal = false"
          style="width: 140px;font-size:15px;"
          >창 닫기</md-button
        >
      </div>
    </div>

    <!--교우검색 팝업 -->
    <member-search-pop-comp
      :is-show.sync="isShowMemberModal"
      @returnResult="onSelectedModalMember"
    ></member-search-pop-comp>

    <!--주소검색 팝업 -->
    <postcode-pop-comp
      :is-show.sync="isShowPostcodeModal"
      @returnResult="handleAddress"
    ></postcode-pop-comp>
  </md-card>
</template>

<script>
import formatter from "@/kuaa/kuaa-formatter";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

import Swal from "sweetalert2";
import moment from "moment";

import { Grid } from "@toast-ui/vue-grid";
import "tui-grid/dist/tui-grid.css";
import "tui-pagination/dist/tui-pagination.css";

import { MemberSearchPopComp, PostcodePopComp } from "@/pages";

export default {
  name: "DonatorEditComp",

  props: {
    mappingCnt: {
      type: Number,
      default: 0
    }
  },

  components: {
    MemberSearchPopComp,
    PostcodePopComp
  },

  created() {
    this.getSemesterCdList();
  },

  watch: {
    "query.agreemAmount"(n) {
      if (n) {
        const strValue = typeof n === 'string' ? n : String(n);
        this.accountNo = (parseInt(strValue.replace(/,/g, '')) / 4000000).toFixed(2);
      }
    },
  "query.sendTo"(val) {
    const sendTo = String(val || "");
    if (sendTo === "1") {
      // 자택
      this.query.agreemZipcd = this.memberInfo.homeZipcd || "";
      this.query.agreemAddress1 = this.memberInfo.homeAddress1 || "";
      this.query.agreemAddress2 = this.memberInfo.homeAddress2 || "";
    } else if (sendTo === "2") {
      // 직장
      this.query.agreemZipcd = this.memberInfo.officeZipcd || "";
      this.query.agreemAddress1 = this.memberInfo.officeAddress1 || "";
      this.query.agreemAddress2 = this.memberInfo.officeAddress2 || "";
    } else if (sendTo === "3") {
      // 기타
      this.query.agreemZipcd = this.query.etcZipcd || "";
      this.query.agreemAddress1 = this.query.etcAddress1 || "";
      this.query.agreemAddress2 = this.query.etcAddress2 || "";
    } else if (sendTo === "4") {
      // 이메일
      this.query.agreemZipcd = "";
      this.query.agreemAddress1 = this.query.eMail || this.memberInfo.eMail || this.memberInfo.eMail2 || "";
      this.query.agreemAddress2 = "";
    } else {
      // 선택 안 함
      this.query.agreemZipcd = "";
      this.query.agreemAddress1 = "";
      this.query.agreemAddress2 = "";
    }
  }
  },
  computed: {},
  data() {
    return {
      isEdit: false,

      isShowMemberModal: false,
      isShowPostcodeModal: false,
      isShowDonatorPrintModal: false,
      accountNo: 0,

      semesterCdList: [],
      memberInfo: {},
      originalSemesterCd: null, // 리스트에서 클릭한 원본 학기 (저장용)
      query: {
        memberNo: null,
        semesterCd: "", //신청학기
        companyName: "", // 직장명
        levelNm: "", // 직위
        managerNm: "", // 담당자
        eMail: "", // 이메일
        secNm: "", // 성명
        secPosition: "", // 부서직위
        officePhone: "", // 직장전화
        celluar: "", // 핸드폰
        etc: "", // 특이사항
        receiptGb: "", // 기부영수증
        agreemZipcd: "", // 약정서우편번호
        agreemAddress1: "", // 약정서발송주소1
        agreemAddress2: "", // 약정서발송주소2
        conditionGive: "", // 지급조건
        conditionDetail: "", // 세부조건
        conditionEtc: "", // 비고
        //'' : ,// 등록금 지급구좌
        agreemAmount: 0, //약정금액
        depositDate: null, // 입금일자
        giveAmount: null, // 실 입급액
        designateGb: null, // 지정여부
        baseAmount: 0, // 기부금(기본재산)
        changeDesc: null, // 약정변동내역
        recomPart: null, // 담당부서(교내포함)
        recomDean: null, // 학장
        recomDirector: null, // 부장(차장)
        recomManager: null, // 담당자
        recomEtc: null, // 비고
        agreemExecDesignate: null, // 직접지명
        agreemExecMendateGb: null, // 교우회 위임
        agreemExecSpecPerson: null, // 특수관계인
        agreemExecEtc: null, // 기타
        agreemFindmanCd: "", // 섭외담당자
        agreemEtc: null, // 비고
        attchFile: null,
        savedImgUrl: "",
        savedFileBaseId: "",
        savedFileName: "",
        fax: null, // 직장 FAX,
        giveGb: null, // 지급형태
        sendCondition: null, // 발송조건
        sendTo: null, // 발송방법
        donateMotive: null, // 기탁계기
        donateStartDate: null, // 기탁개시일
        baseStartDate: null, // 기본재산편입일
        etcZipcd: null, // 기타 우편번호
        etcAddress1: null, // 기타 주소1
        etcAddress2: null, // 기타 주소2
      }
    };
  },
  methods: {
    getDateFormat: formatter.getDateFormat,
    getSemesterCdList() {
      kuaaFnc.fncSemesterCodes(null, res => {
        this.semesterCdList = res.data.data.contents;
      });
      console.log("getSemesterCdList=", this.semesterCdList);
    },
    resetEditView() {
      this.$emit("addDonor");
    },
    clearQuery(isQueryOnly) {
      if (!isQueryOnly) {
        this.memberInfo = {};
      }
      this.accountNo = 0;
      this.query = {
        memberNo: null,
        semesterCd: "", //신청학기
        companyName: "", // 직장명
        levelNm: "", // 직위
        managerNm: "", // 담당자
        eMail: "", // 이메일
        secNm: "", // 성명
        secPosition: "", // 부서직위
        officePhone: "", // 직장전화
        celluar: "", // 핸드폰
        etc: "", // 특이사항
        receiptGb: "", // 기부영수증
        agreemZipcd: "", // 약정서우편번호
        agreemAddress1: "", // 약정서발송주소1
        agreemAddress2: "", // 약정서발송주소2
        conditionGive: "", // 지급조건
        conditionDetail: "", // 세부조건
        conditionEtc: "", // 비고
        agreemAmount: 0, //약정금액
        depositDate: null, // 입금일자
        giveAmount: null, // 실 입금액
        designateGb: null, // 지정여부
        baseAmount: 0, // 기부금(기본재산)
        changeDesc: null, // 약정변동내역
        recomPart: null, // 담당부서(교내포함)
        recomDean: null, // 학장
        recomDirector: null, // 부장(차장)
        recomManager: null, // 담당자
        recomEtc: null, // 비고
        agreemExecDesignate: null, // 직접지명
        agreemExecMendateGb: null, // 교우회 위임
        agreemExecSpecPerson: null, // 특수관계인
        agreemExecEtc: null, // 기타
        agreemFindmanCd: "", // 섭외담당자
        agreemEtc: null, // 비고
        attchFile: null,
        savedImgUrl: "",
        savedFileBaseId: "",
        savedFileName: "",
        fax: null, // 직장 FAX,
        giveGb: null, // 지급형태
        sendCondition: null, // 발송조건
        sendTo: null, // 발송방법
        donateMotive: null, // 기탁계기
        donateStartDate: null, // 기탁개시일
        baseStartDate: null, // 기본재산편입일
        etcZipcd: null, // 기타 우편번호
        etcAddress1: null, // 기타 주소1
        etcAddress2: null, // 기타 주소2
      };
    },

    setDonatorReciptPrint() {
      let today = new Date();

      let year = today.getFullYear(); // 년도
      let month = today.getMonth() + 1; // 월
      let date = today.getDate(); // 날짜
      let day = today.getDay(); // 요일

      document.getElementById("today").innerText =
        year + "." + month + "." + date;
      this.isShowDonatorPrintModal = true;
    },

    printDonatorReceipt() {
      document.getElementById("printbutton").style.display = "none";

      window.onbeforeprint = function() {
        document.body.outerHTML = document.getElementById("print").outerHTML;
      };
      window.onafterprint = function() {
        location.href = window.location.href;

        document.getElementById("printbutton").style.display = "";
      };
      window.print();
    },

    onSelectedModalMember(item) {
      console.log("========================================");
      console.log("onSelectedModalMember 메서드 호출됨!");
      console.log("========================================");
      console.log("item:", item);
      
      if (!item) {
        console.log("item이 null입니다");
        return;
      }
      
      this.memberInfo = item;
      this.query.memberNo = item.memberNo;
      console.log("memberInfo 설정됨:", this.memberInfo);
      console.log("memberNo 설정됨:", this.query.memberNo);
      
      // 가장 최근 학기의 기부자 정보 자동 로드
      console.log("기부자 정보 조회 시작...");
      kuaaApi.sendServer(
        URL_CONST.GET_SCHA_DONOR_LIST,
        {
          memberNo: item.memberNo
        },
        "post",
        response => {
          console.log("API 응답:", response);
          if (
            response.data &&
            response.data.result &&
            response.data.data.contents &&
            response.data.data.contents.length
          ) {
            // 가장 최근 학기의 기부자 정보 설정
            const donorData = response.data.data.contents[0];
            console.log("기부자 데이터:", donorData);
            
            // 날짜 포맷팅
            if (donorData.depositDate) {
              donorData.depositDate = kuaaFnc.getDateFormatter(donorData.depositDate);
            }
            if (donorData.baseStartDate) {
              donorData.baseStartDate = kuaaFnc.getDateFormatter(donorData.baseStartDate);
            }
            if (donorData.donateStartDate) {
              donorData.donateStartDate = kuaaFnc.getDateFormatter(donorData.donateStartDate);
            }
            
            this.query = JSON.parse(JSON.stringify(donorData));
            this.isEdit = true;
            
            // 조회할 학기를 최신학기로 설정
            if (this.semesterCdList.length > 0) {
              this.query.semesterCd = this.semesterCdList[0].code;
              // 저장할 학기도 최신학기로 설정 (사용자가 조회학기를 바꾸지 않으면 최신학기로 저장)
              this.originalSemesterCd = this.semesterCdList[0].code;
              console.log("조회 학기를 최신학기로 설정:", this.query.semesterCd);
              console.log("저장할 학기를 최신학기로 설정:", this.originalSemesterCd);
            }
            
            console.log("기부자 정보 설정 완료!");
            console.log("설정된 query:", this.query);
          } else {
            console.log("기부자 정보 없음 - 신규 입력 모드로 전환");
            // 기부자 정보가 없으면 신규 입력 모드
            this.clearQuery(true);
            this.query.memberNo = item.memberNo;
            if (this.semesterCdList.length > 0) {
              this.query.semesterCd = this.semesterCdList[0].code;
              this.originalSemesterCd = this.query.semesterCd;
            }
            this.isEdit = false;
          }
        }
      );
    },
    setQuery(obj) {
      if (obj) {
        obj = JSON.parse(JSON.stringify(obj));
        obj.depositDate = kuaaFnc.getDateFormatter(obj.depositDate);
        this.query = obj;
        // 리스트에서 클릭한 원본 학기를 저장 (저장 시 이 값 사용)
        this.originalSemesterCd = obj.semesterCd;
        this.getMemberInfoByNo();
        this.isEdit = true;
        console.log("setQuery=", this.query);
        console.log("originalSemesterCd (저장용)=", this.originalSemesterCd);
      } else {
        this.clearQuery();
        this.query.semesterCd = this.semesterCdList[0]["code"]; // 신규입력시 마지막 학기
        this.originalSemesterCd = this.query.semesterCd; // 신규 시에도 원본 학기 설정
        this.isEdit = false;
      }
    },
    getMemberInfoByNo() {
      kuaaApi.sendServer(
        URL_CONST.GET_MEMBER_LIST,
        { memberNo: this.query.memberNo },
        "post",
        response => {
          if (response.data.result) {
            this.memberInfo = response.data.data.contents[0];
          } else {
            let modalOptions = kuaaFnc.getSwalModaloptions();
            modalOptions.html = `회원 정보 조회 실패 하였습니다.`;
            Swal.fire(modalOptions);
          }
        }
      );
    },
    handleAddress: function(data) {
      let zonecode = data.zonecode; // 우편번호
      let roadAddress = data.roadAddress; // 도로명주소
      let jibunAddress = data.jibunAddress; // 지번 주소
      let fullAddress = data.address; // 기본주소
      let extraAddress = "";

      if (data.addressType === "R") {
        if (data.bname !== "") extraAddress += data.bname;
        if (data.buildingName !== "") {
          extraAddress +=
            extraAddress !== "" ? `, ${data.buildingName}` : data.buildingName;
        }

        fullAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
      }
        if (this.selectedAddressType === 'agreem') {
          this.query.agreemZipcd = zonecode;
          this.query.agreemAddress1 = roadAddress;
          this.query.agreemAddress2 = "";
        } else if (this.selectedAddressType === 'etc') {
          this.query.etcZipcd = zonecode;
          this.query.etcAddress1 = roadAddress;
          this.query.etcAddress2 = "";
        }
        this.isShowPostcodeModal = false;
    },
    addressModalOpen: function(addressType, event) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      this.isShowPostcodeModal = true;
      this.selectedAddressType = addressType;
    },
    saveDonator() {
      let modalOptions = kuaaFnc.getSwalModaloptions("confirm", {
        html: "저장 하시겠습니까?"
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          let params = JSON.parse(JSON.stringify(this.query));
          // 저장 시에는 항상 원본 학기(리스트에서 클릭한 학기) 사용
          params.semesterCd = this.originalSemesterCd;
          params.depositDate = kuaaFnc.cleanDateFormatter(params.depositDate);
          params.baseStartDate = kuaaFnc.cleanDateFormatter(params.baseStartDate);
          params.donateStartDate = kuaaFnc.cleanDateFormatter(params.donateStartDate);
          params.celluar = kuaaFnc.parseOnlyNum(params.celluar);
          if (!params.giveAmount) {
            params.giveAmount = 0;
          } else {
            const giveAmountStr = typeof params.giveAmount === 'string' ? params.giveAmount : String(params.giveAmount);
            params.giveAmount = Number(giveAmountStr.replace(/,/g, ''));
          }
          if (!params.baseAmount) params.baseAmount = 0;
          if (!params.agreemAmount) {
            params.agreemAmount = 0;
          } else {
            const agreemAmountStr = typeof params.agreemAmount === 'string' ? params.agreemAmount : String(params.agreemAmount);
            params.agreemAmount = Number(agreemAmountStr.replace(/,/g, ''));
          }
          modalOptions = kuaaFnc.getSwalModaloptions();
          kuaaApi.sendServer(
            URL_CONST.SAVE_SCHA_DONOR_LIST,
            params,
            "post",
            response => {
              if (response.data.success) {
                if (this.fileName != "") {
                  this.savePhoto(response.data.data);
                }
                kuaaFnc.showSwal("기부자 관리", `저장 되었습니다.`);
                this.$emit("onDonorSave", false, true);
              } else {
                kuaaFnc.showSwal("기부자 관리", `저장 실패 하였습니다.`);
              }
            }
          );
        }
      });
    },

    deleteDonator() {
      let modalOptions = null;

      if (this.mappingCnt > 0) {
        modalOptions = kuaaFnc.getSwalModaloptions("confirm", {
          html:
            "매칭된 장학생이 있습니다. 삭제 하시겠습니까?<br>[매칭정보도 함께 삭제합니다]"
        });
      } else {
        modalOptions = kuaaFnc.getSwalModaloptions("confirm", {
          html: "삭제 하시겠습니까?"
        });
      }

      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          let params = {
            memberNo: this.query.memberNo,
            semesterCd: this.query.semesterCd,
            mappingDataCnt: this.mappingCnt
          };
          modalOptions = kuaaFnc.getSwalModaloptions();
          kuaaApi.sendServer(
            URL_CONST.DELETE_SCHA_DONOR_LIST,
            params,
            "post",
            response => {
              console.log(response);
              if (response.data.success) {
                this.isEdit = false;
                this.clearQuery();
                kuaaFnc.showSwal("기부자 관리", `삭제 되었습니다.`);
                this.$emit("onDonorSave", true);
              } else {
                kuaaFnc.showSwal("기부자 관리", `삭제 실패 하였습니다.`);
              }
            }
          );
        }
      });
    },
    changeSemesterCd() {
      if (!this.query.semesterCd || this.query.semesterCd == "") {
        return;
      }

      if (this.query.memberNo && this.query.memberNo != "") {
        let modalOptions = kuaaFnc.getSwalModaloptions();
        let params = {
          memberNo: this.query.memberNo,
          semesterCd: this.query.semesterCd
        };
        
        kuaaApi.sendServer(
          URL_CONST.GET_SCHA_DONOR_LIST,
          {
            memberNo: this.query.memberNo,
            semesterCd: this.query.semesterCd
          },
          "post",
          response => {
            if (response.data.result) {
              if (response.data.data.contents.length) {
                // 조회한 데이터로 폼을 채움
                const donorData = response.data.data.contents[0];
                
                // 날짜 포맷팅
                if (donorData.depositDate) {
                  donorData.depositDate = kuaaFnc.getDateFormatter(donorData.depositDate);
                }
                if (donorData.baseStartDate) {
                  donorData.baseStartDate = kuaaFnc.getDateFormatter(donorData.baseStartDate);
                }
                if (donorData.donateStartDate) {
                  donorData.donateStartDate = kuaaFnc.getDateFormatter(donorData.donateStartDate);
                }
                
                this.query = JSON.parse(JSON.stringify(donorData));
                // 사용자가 학기를 변경했으므로, 그 학기로 저장
                this.originalSemesterCd = params.semesterCd;
                
                console.log("학기 변경 - 조회된 데이터로 폼 구성");
                console.log("저장할 학기 변경:", this.originalSemesterCd);
                
                this.$emit("onClickTab");
              } else {
                this.clearQuery(true);
                this.query.memberNo = params.memberNo;
                this.query.semesterCd = params.semesterCd;
                // 사용자가 학기를 변경했으므로, 그 학기로 저장
                this.originalSemesterCd = params.semesterCd;
              }
            } else {
              modalOptions.html = `기부 정보 조회 실패 하였습니다.`;
              Swal.fire(modalOptions);
            }
          }
        );
      }
    },
    // 요청변경 (적전학기 불러오기 -> 가장 최근 학기 불러오기)로 변경
    // loadPrevSemesterInfo() {
    //   if (!this.query.semesterCd || !this.semesterCdList.length) return;

    //   // 현재 선택된 학기의 index 찾기
    //   const idx = this.semesterCdList.findIndex(
    //     item => item.code === this.query.semesterCd
    //   );
    //   if (idx === -1 || idx === this.semesterCdList.length - 1) {
    //     kuaaFnc.showSwal("안내", "직전 학기가 없습니다.");
    //     return;
    //   }

    //   // 직전 학기 코드
    //   const prevSemester = this.semesterCdList[idx + 1].code;

    //   // 서버에서 직전 학기 정보 조회
    //   kuaaApi.sendServer(
    //     URL_CONST.GET_SCHA_DONOR_LIST,
    //     {
    //       memberNo: this.query.memberNo,
    //       semesterCd: prevSemester
    //     },
    //     "post",
    //     response => {
    //       if (
    //         response.data.result &&
    //         response.data.data.contents &&
    //         response.data.data.contents.length
    //       ) {
    //         this.setQuery(response.data.data.contents[0]);
    //         this.query.semesterCd = this.semesterCdList[idx].code; // 다시 현재 학기로 복원
    //         kuaaFnc.showSwal("안내", "직전 학기 정보가 불러와졌습니다.");
    //       } else {
    //         kuaaFnc.showSwal("안내", "직전 학기 정보가 없습니다.");
    //       }
    //     }
    //   );
    // },
loadLatestSemesterInfo() {
  kuaaApi.sendServer(
    URL_CONST.GET_SCHA_DONOR_LIST,
    {
      memberNo: this.query.memberNo,
    },
    "post",
    response => {
      if (
        response.data.result &&
        response.data.data.contents &&
        response.data.data.contents.length
      ) {
        this.setQuery(response.data.data.contents[0]);
        // 가장 최근 학기(리스트의 첫 번째 항목) 선택
        this.query.semesterCd = this.semesterCdList[0]?.code || "";
        kuaaFnc.showSwal("안내", "가장 최근 학기 정보가 불러와졌습니다.");
      } else {
        kuaaFnc.showSwal("안내", "정보가 없습니다.");
      }
    }
  );
},
    onClickSearchFile(event) {
      let input = document.getElementById("donatorFileInput");
      input.onchange = e => {
        let file = e.target.files[0];
        this.fileName = file.name;
        this.attchFile = file;
        this.orgFileNm = file.name;
      };

      console.log(input.fileName);

      input.click();
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
    },
    onClickDownLoad() {
      if (!this.query.orgFileNm) return false;
      location.href =
        URL_CONST.FILE_DOWN_LOAD + "?fileBaseId=" + this.query.fileBaseId;
    },
    onClickDeleteFile() {
      if (!this.query.orgFileNm) return false;
      let modalOptions = kuaaFnc.getSwalModaloptions("confirm", {
        html: "파일을 삭제 하시겠습니까?"
      });
      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          console.log(this.query.fileBaseId);
          kuaaApi.sendServer(
            URL_CONST.FILE_DELTE,
            this.query.fileBaseId,
            "post",
            response => {
              if (response.data.success) {
                kuaaFnc.showSwal("파일 관리", `삭제 되었습니다.`);
                this.$emit("onDonorSave", true);
              } else {
                kuaaFnc.showSwal("파일 관리", `삭제 실패 하였습니다.`);
              }
            }
          );
        }
      });
    },
    savePhoto(data) {
      if (this.fileName != null) {
        let formData = new FormData();
        formData.append("uploadFiles", this.attchFile);
        formData.append("fileCtgCd", "DONOR");
        formData.append(
          "fileBizId",
          this.query.memberNo + this.query.semesterCd
        );

        kuaaApi.sendServerMixData(
          URL_CONST.FILE_UPLOAD,
          formData,
          "post",
          res => {
            if (res.data.success) {
              if (res.data.data[0].fileBaseId) {
                this.savedImgUrl =
                  URL_CONST.FILE_DOWN_LOAD +
                  "?fileBaseId=" +
                  res.data.data[0].fileBaseId;
                this.savedFileBaseId = res.data.data[0].fileBaseId;
                this.fileName = null;
                this.$emit("onDonorSave", false, true);
              }
            } else {
              kuaaFnc.showSwal("약정서 첨부", "저장 실패!");
            }
          }
        );
      }
    }
  }
};
</script>
